import constants from './constants';

export default {
  [constants.CONTACT_US_REPORT_BUG]:
    'https://t.corp.amazon.com/create/templates/e03b359a-837f-4408-afe7-d4212a5bc9cf',
  [constants.CONTACT_US_ADMIN_SUPPORT]:
    'https://t.corp.amazon.com/create/templates/f6f95403-94fa-4e59-8592-841d07b3d96f',
  [constants.CONTACT_US_FEAT_REQUEST]:
    'https://t.corp.amazon.com/create/templates/3ebbc630-8529-4b52-9ca8-7998f65ef5db',
  [constants.CONTACT_US_JOIN_SLACK_CHANNEL]:
    'https://amazon.enterprise.slack.com/archives/C017N8C00M8',
};
